import type { FC } from "react";

import { useClientContext } from "~/contexts/client-context";
import type { LayoutV2, Pages } from "~/core";
import { Header } from "~/features/header/Header";
import { HeaderV4 } from "~/features/headerV4/HeaderV4";
import { usePlayNowUrl } from "~/shared/utils/aff-integration";
import { useGtmContext } from "~/shared/utils/gtm-sdk/provider";
import { useAction } from "~/widgets/use-action";

export const MainHeaderV2: FC<{ data: LayoutV2 }> = ({ data }) => {
  const { gtm } = useGtmContext();
  const playNowUrl = usePlayNowUrl();
  const { playerID, featureFlags, language, availableLanguages, languages } =
    useClientContext();
  const redirectToRoom = (): void => {
    if (playNowUrl) {
      window.location.href = playNowUrl;
    }
  };

  const { callAction: onCallAction, isActionInactive } = useAction();
  const headerAnalytics = {
    clickHeaderMain(triggerUrl: string) {
      const triggerId = triggerUrl.replace(/^\/+|\/+$/g, "");
      gtm.clickHeaderMain({
        eventTime: new Date(),
        playerID,
        triggerId: triggerId === "promotions" ? "Features" : triggerId,
      });
    },
    clickHeaderSub(targetUrl: string) {
      const targetId =
        targetUrl
          .replace(/^\/|\/$/g, "")
          .split("/")
          .at(-1) ?? "";

      gtm.clickHeaderSub({
        eventTime: new Date(),
        playerID,
        targetId,
        // одна из кнопок Хедера в котором кликнули на элемент Выпадающего меню (пока только Features). Аналитика требует название кнопки как на сайте
        triggerId: "Features",
        screenName: "mainPage",
      });
    },
    createAccountHeader() {
      gtm.createAccountHeader({
        eventTime: new Date(),
        playerID,
        screenName: "signUp",
      });
      redirectToRoom();
    },
    loginHeader() {
      gtm.loginHeader({
        eventTime: new Date(),
        playerID,
        screenName: "logIn",
      });
      redirectToRoom();
    },
  };

  const getUrl = (detailedPage: Pages): string => {
    if (!detailedPage?.slug) {
      return `/`;
    }

    const { segment, slug } = detailedPage;
    if (segment) {
      return `/${segment}/${slug}`;
    } else {
      return `/${slug}`;
    }
  };
  const headerData = {
    ...data,
    language,
    availableLanguages: availableLanguages ?? [],
    languages: languages ?? [],
  };
  return (
    <>
      {featureFlags.getItem("menuConstructor").enabled && headerData ? (
        <HeaderV4
          {...headerAnalytics}
          data={headerData}
          getUrl={getUrl}
          onCallAction={onCallAction}
          isActionInactive={isActionInactive}
        />
      ) : (
        <Header
          playNowLink={playNowUrl}
          featureFlags={{
            isNavigationEnabled: featureFlags.getItem("headerNavigationLinks")
              .enabled,
            isLanguageSelectorEnabled: featureFlags.getItem(
              "headerLanguageSelector",
            ).enabled,
            isCreateButtonEnabled:
              featureFlags.getItem("headerCreateButton").enabled,
          }}
          analytics={headerAnalytics}
        />
      )}
    </>
  );
};
